import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppBasicsModule } from '@meddev/fe-shared';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { HrefPreventDefaultDirective } from '../../_directives/href-prevent-default.directive';
// directives
import { UnwrapTagDirective } from '../../_directives/unwrap-tag.directive';
// modules
import { ComponentModule } from '../components/component.module';
import { HomeComponent } from '../pages/home/home.component';
import { SettingsComponent } from '../pages/settings/settings.component';
import { AsideNavComponent } from './aside-nav/aside-nav.component';
import { AsnHdStatusComponent } from './aside-nav/asn-hd-status/asn-hd-status.component';
import { AsnStatusComponent } from './aside-nav/asn-status/asn-status.component';
import { AsnTelephonyStatusComponent } from './aside-nav/asn-telephony-status/asn-telephony-status.component';
import { HeaderNavComponent } from './header-nav/header-nav.component';
// components
import { HeaderNotificationElementComponent } from './header-nav/header-notification-element/header-notification-element.component';
import { QuickSidebarComponent } from './quick-sidebar/quick-sidebar.component';

@NgModule({
    exports: [HeaderNavComponent, QuickSidebarComponent, HrefPreventDefaultDirective, AsideNavComponent],
    imports: [
        CommonModule,
        RouterModule,
        ComponentModule,
        NgxPermissionsModule,
        NgbModule,
        NgScrollbarModule,
        OverlayModule,
        AppBasicsModule,
        HeaderNavComponent,
        QuickSidebarComponent,
        HrefPreventDefaultDirective,
        UnwrapTagDirective,
        HomeComponent,
        SettingsComponent,
        AsideNavComponent,
        HeaderNotificationElementComponent,
        AsnHdStatusComponent,
        AsnStatusComponent,
        AsnTelephonyStatusComponent,
    ],
})
export class LayoutModule {}
